import { render, staticRenderFns } from "./Destinations.vue?vue&type=template&id=ecd42dac&"
import script from "./Destinations.vue?vue&type=script&lang=js&"
export * from "./Destinations.vue?vue&type=script&lang=js&"
import style0 from "./Destinations.vue?vue&type=style&index=0&id=ecd42dac&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports